var map = {
	"./1.1.0search.png": "7KjS",
	"./Africa.png": "YCy2",
	"./America.png": "uZws",
	"./Asia.png": "z55X",
	"./Europe.png": "4jJr",
	"./Oceania.png": "GKFq",
	"./QA/answer_none.png": "jUFw",
	"./QA/delete.png": "Mk+9",
	"./QA/detail_answer.png": "KX3s",
	"./QA/detail_like.png": "J3bQ",
	"./QA/detail_liked.png": "m/wX",
	"./QA/detail_question.png": "KxWr",
	"./QA/list_like.png": "nR2b",
	"./QA/list_liked.png": "7xA0",
	"./QA/list_question.png": "MBt7",
	"./QA/reject_warn.png": "6GYD",
	"./QA/search.png": "KExp",
	"./QA/search_delete.png": "h2RS",
	"./QA/write.png": "AtnF",
	"./Russia.jpg": "fAsY",
	"./about-address.png": "U01O",
	"./about-banner1.png": "nWVA",
	"./about-logo.png": "aIKQ",
	"./about-map.png": "L6cn",
	"./about-phone.png": "RaG/",
	"./about-us/hr-qrcode.png": "p4So",
	"./acadmy/banner.png": "cWKw",
	"./acadmy/banner_bg.jpg": "SqTH",
	"./acadmy/banner_zan.png": "wrN7",
	"./acadmy/info_speaker.png": "9Ixi",
	"./acadmy/info_time.png": "ATsw",
	"./acadmy/list_beimei.png": "luh8",
	"./acadmy/list_dayangzhou.png": "obfb",
	"./acadmy/list_dongnanya.png": "QDgY",
	"./acadmy/list_new.png": "CEyd",
	"./acadmy/list_open.png": "oolb",
	"./acadmy/list_ouzhou.png": "iaK/",
	"./acadmy/list_qita.png": "Wbvd",
	"./acadmy/nav_guide.png": "ppCU",
	"./acadmy/nav_message.png": "cMZ8",
	"./acadmy/nav_video.png": "ceFY",
	"./acadmy/nav_visa.png": "UbUw",
	"./acadmy/right-enter.png": "DqnO",
	"./acadmy/share.png": "KknR",
	"./acadmy/time-white.png": "Zal/",
	"./acadmy/time.png": "d5MY",
	"./acadmy/video-active.png": "tEOh",
	"./acadmy/video-logo.png": "c+v3",
	"./acadmy/video.png": "+6rj",
	"./acadmy/video_wrong.png": "7MpX",
	"./acadmy/view-white.png": "Kxy1",
	"./acadmy/view.png": "Gnab",
	"./acadmy/view_shadow.png": "7OmF",
	"./acadmy/wechat_share.png": "2nlL",
	"./accept-scope.png": "w8Pw",
	"./activity-pop.png": "7GOC",
	"./activity/full-amount-activity/current-discount.png": "sL7R",
	"./activity/full-amount-activity/default-discount.png": "rtue",
	"./activity/full-amount-activity/received-discount.png": "yi8h",
	"./activity/full-amount-activity/rule-icon.png": "LsFQ",
	"./activity/full-amount-activity/rule-title-bg.png": "qXBx",
	"./activity/three-order-activity/activity-dialog-title-default.png": "6DaZ",
	"./activity/three-order-activity/activity-dialog-title-finish.png": "82DA",
	"./activity/three-order-activity/activity-dialog-title-first.png": "vXDj",
	"./activity/three-order-activity/activity-dialog-title-second.png": "MXkc",
	"./activity/three-order-activity/blur-title-bg.png": "1xYi",
	"./activity/three-order-activity/coupon-blur.png": "Kh4S",
	"./activity/three-order-activity/coupon-recevice-gou.png": "v6xM",
	"./activity/three-order-activity/coupon-receviced-gou.png": "nOas",
	"./activity/three-order-activity/dialog-close-icon.png": "HMqy",
	"./activity/three-order-activity/discount-coupon-current.png": "ATQC",
	"./activity/three-order-activity/discount-coupon-default.png": "lsAv",
	"./activity/three-order-activity/icon_notify.png": "Qmn5",
	"./activity/three-order-activity/index-equity-coupon.png": "aUIq",
	"./activity/three-order-activity/index-equity-package.png": "mFbT",
	"./activity/three-order-activity/index-equity-person.png": "q61z",
	"./activity/three-order-activity/index-three-order-coupon-expired.png": "dZX6",
	"./activity/three-order-activity/index-three-order-coupon-used.png": "8FCV",
	"./activity/three-order-activity/index-three-order-coupon.png": "NHhb",
	"./activity/three-order-activity/rule-tip.png": "LR+b",
	"./activity/three-order-activity/shine.png": "ln+Z",
	"./activity/three-order-activity/title-blur-point.png": "CKxN",
	"./activity/three-order-activity/top-shine.png": "zS/w",
	"./activityClose.png": "RkBR",
	"./activityNot.png": "KjRK",
	"./add.png": "kaoy",
	"./address.png": "Sg/g",
	"./address/address_none.png": "NFOU",
	"./admin-order/arrow.png": "zhjC",
	"./admin-order/close.png": "AXVv",
	"./admin-order/need_delivery.png": "8VNq",
	"./admin-order/notice.png": "fjxl",
	"./admin-order/phone.png": "9fvI",
	"./adv-bg.png": "puhr",
	"./adv-border-hover.png": "E2mR",
	"./adv-border.png": "IQag",
	"./ali-phone.png": "QXiG",
	"./alipay.png": "AyFb",
	"./android-code.png": "dB5l",
	"./animation-index1.png": "05Na",
	"./animation-index2.png": "DSTc",
	"./animation-index3.png": "RwNa",
	"./animation-index4.png": "iE//",
	"./animation-index5.png": "C6uO",
	"./animation-index6.png": "y6CV",
	"./application/add.png": "vuuN",
	"./application/arrow-back.png": "O8CB",
	"./application/arrow-off.png": "FAZ8",
	"./application/arrow-on.png": "w8re",
	"./application/delelte.png": "8CFt",
	"./application/express.png": "YXjK",
	"./application/invalid.png": "DxF6",
	"./application/next-step.png": "fHLF",
	"./application/previous-step.png": "cL34",
	"./application/upload.png": "I7IV",
	"./application/valid-white.png": "BEdZ",
	"./application/valid.png": "cv6M",
	"./arrow-down.png": "pUVN",
	"./article-null.png": "1fmA",
	"./asia-1.jpg": "wH07",
	"./asia-2.jpg": "LwQw",
	"./attention-paper.png": "t2k5",
	"./attention.png": "RFCc",
	"./august/banner.png": "tboJ",
	"./august/noproduct.png": "YJFa",
	"./ba1.png": "zCvj",
	"./ba2.png": "hW3X",
	"./ba3.png": "xXuH",
	"./ba4.png": "Y0gD",
	"./back-gray.png": "G5FW",
	"./back.png": "ADGn",
	"./back@2x.png": "2xIC",
	"./back@3x.png": "A8+s",
	"./banliwenhao.png": "9pGe",
	"./banner/banner03.jpg": "dYmP",
	"./banner/banner04.jpg": "T4kL",
	"./banner01.png": "Ty2t",
	"./banner02.png": "E0L8",
	"./banner09.jpg": "0L4+",
	"./banner090501-2.jpg": "8n4N",
	"./banner090502.jpg": "RgmK",
	"./banner090503.jpg": "Jy2/",
	"./banner110.jpg": "NViZ",
	"./banner5.jpg": "7ext",
	"./bg-0.png": "pB1t",
	"./bg-1.png": "AW7I",
	"./bg-2.png": "z0hZ",
	"./bg-3.png": "KcEG",
	"./bg-4.png": "GgaU",
	"./bg.jpg": "NAbu",
	"./bg2.jpg": "pNAw",
	"./bind-code-r.png": "3R0I",
	"./bind-code.png": "r7MO",
	"./bind.png": "cQmb",
	"./bind2.png": "aWu9",
	"./bottom-logo.png": "196j",
	"./bottom-phone.png": "5ovc",
	"./brand-white.png": "HR4D",
	"./brand.png": "O5Eb",
	"./call.png": "24ia",
	"./camara-upload-forbbiden.png": "dsqa",
	"./camara-upload.png": "O+Xq",
	"./camera.png": "O112",
	"./chinapay.png": "EFuB",
	"./city-agent/01.png": "VS3w",
	"./city-agent/02.png": "3U5L",
	"./city-agent/03.png": "uPjy",
	"./city-agent/04.png": "/bA7",
	"./city-agent/05.png": "Nqrn",
	"./city-agent/06.png": "/X+f",
	"./city-agent/application-add.png": "G8fd",
	"./city-agent/application-bg.png": "8wcp",
	"./city-agent/arrow-down.png": "qjm1",
	"./city-agent/arrow-up.png": "waTY",
	"./city-agent/banner.jpg": "QqSX",
	"./city-agent/entrepreneur.png": "YGTi",
	"./city-agent/icon-channel.png": "w+R6",
	"./city-agent/icon-income.png": "PTQh",
	"./city-agent/icon-intelligent.png": "T99/",
	"./city-agent/king-of-contacts.png": "I/wg",
	"./city-agent/obtain-bg.jpg": "453f",
	"./city-agent/old-driver.png": "elX0",
	"./city-agent/step_01.png": "CSkw",
	"./city-agent/step_02.png": "bYNd",
	"./city-agent/step_03.png": "GHt4",
	"./city-agent/step_04.png": "/KBC",
	"./city-agent/step_05.png": "e2Rj",
	"./city-agent/title.png": "NgvG",
	"./city-agent/title_left.png": "ohXt",
	"./city-agent/title_right.png": "vzG0",
	"./close.png": "elHn",
	"./close@2x.png": "TRJQ",
	"./close@3x.png": "PJWc",
	"./collapse.png": "yaGc",
	"./color-dai-only.png": "HmL9",
	"./color-dai.png": "jnkF",
	"./color-no-dai.png": "g0T2",
	"./comment/default-avatar.png": "KyHF",
	"./comment/no-comment.png": "LoWD",
	"./comment/rate1.png": "FiYQ",
	"./comment/rate2.png": "JZX3",
	"./comment/rate3.png": "D/gL",
	"./common/footer-logo.png": "MQ6Z",
	"./common/header-logo-blue.png": "F2tB",
	"./common/header-logo-white.png": "nR2Q",
	"./country/access-visa.png": "K8yW",
	"./country/blue-down-arrow.png": "L2j6",
	"./country/blue-triangle.png": "TWjS",
	"./country/business.png": "lzt9",
	"./country/calender.png": "8oA1",
	"./country/coupon.png": "RycP",
	"./country/default-product-type.png": "r98W",
	"./country/delete.png": "Gwz/",
	"./country/gray-down-arrow.png": "kdER",
	"./country/gray-triangle.png": "U7r9",
	"./country/location.png": "z8Tm",
	"./country/medical-visa.png": "s/4+",
	"./country/none-product.png": "gwyI",
	"./country/notice-info.png": "mfE1",
	"./country/question.png": "hTsh",
	"./country/remove.png": "voma",
	"./country/short-term-study.png": "+gpV",
	"./country/special-price.png": "LUOs",
	"./country/strategy/A.png": "3Am1",
	"./country/strategy/B.png": "05/5",
	"./country/strategy/C.png": "4HJk",
	"./country/strategy/D.png": "5Fgl",
	"./country/strategy/S.png": "C/cl",
	"./country/trip.png": "uQlJ",
	"./country/visit-friends.png": "ilyA",
	"./country/wheat-left.png": "Dgti",
	"./country/wheat-right.png": "Q9B8",
	"./coupon/add.png": "JRKR",
	"./coupon/charge-coupon-background.png": "K59V",
	"./coupon/charge-coupon-button.png": "wubX",
	"./coupon/charge-coupon-item.png": "1Tbj",
	"./coupon/coupon-modal-bottom.png": "UaHH",
	"./coupon/coupon-modal-middle.png": "5wtZ",
	"./coupon/coupon-modal-top.png": "/efK",
	"./coupon/coupon-selected.png": "XtIy",
	"./coupon/coupon.png": "6OHX",
	"./coupon/ensure-bg.png": "TYgS",
	"./coupon/ensure-select.png": "SbC+",
	"./coupon/expired.png": "aVOO",
	"./coupon/expired_ensure_1.png": "qx98",
	"./coupon/expired_ensure_2.png": "3buY",
	"./coupon/expired_ensure_3.png": "3/jm",
	"./coupon/expired_other_1.png": "vXbx",
	"./coupon/expired_other_2.png": "Ec0L",
	"./coupon/expired_other_3.png": "aaaW",
	"./coupon/linner.png": "w7Rb",
	"./coupon/modal-bg-strip.png": "SFWH",
	"./coupon/modal-bg.png": "WR1M",
	"./coupon/modal-close.png": "bZr+",
	"./coupon/modal-star.png": "xbvX",
	"./coupon/my-coupon-bg-expired.png": "Qo9e",
	"./coupon/my-coupon-strip-expired.png": "BekZ",
	"./coupon/none-coupon.png": "K0KN",
	"./coupon/usage.png": "/zkI",
	"./coupon/used.png": "vdrS",
	"./covid-19.png": "DhJl",
	"./cruise.jpg": "SYtj",
	"./delete.png": "DKbd",
	"./earlist-nodata.png": "00R/",
	"./empty-result.png": "7Y4Y",
	"./entri/collepse.png": "ltZy",
	"./express-location.png": "FOAX",
	"./eye.png": "hxC8",
	"./favicon.png": "6v5f",
	"./fee.png": "SDM0",
	"./fg_accompany.png": "ovBS",
	"./fg_address.png": "i5Nh",
	"./fg_attention.png": "sp4S",
	"./fg_banli.png": "Q2Vz",
	"./fg_date.png": "kZTL",
	"./fg_date_white.png": "7OKQ",
	"./fg_doc.png": "SOtD",
	"./fg_name.png": "s1Oy",
	"./fg_offline_notice.png": "i6kn",
	"./fg_process.png": "j+gZ",
	"./float-arrow.png": "7ug8",
	"./float-phone-hover.png": "XMMP",
	"./float-phone.png": "RriJ",
	"./float-qq.png": "xndR",
	"./follow-modal/qrcode-modal-test.jpg": "acNy",
	"./follow-modal/qrcode-modal.png": "CQLm",
	"./follow-modal/wechat-screenshot.png": "r2U+",
	"./fr1.png": "JDKQ",
	"./fr2.png": "tY+9",
	"./fr3.png": "xNUd",
	"./fr4.png": "T17y",
	"./fr5.png": "lLE1",
	"./fr6.png": "t7GH",
	"./global-car.jpg": "Y96T",
	"./global-medical.jpg": "7O7F",
	"./global-round-trip.jpg": "6M2c",
	"./gongan.png": "6QCy",
	"./group-visa/fail-recognition.gif": "K0fr",
	"./group-visa/icon-check-mark.png": "mTz+",
	"./group-visa/icon-delete.png": "iLLW",
	"./group-visa/icon-modify.png": "jqJe",
	"./group-visa/icon-recommend.png": "fggB",
	"./group-visa/loading.gif": "8atM",
	"./group-visa/quality-surveillance-hover.png": "+0bT",
	"./group-visa/quality-surveillance.png": "c59/",
	"./group-visa/success-recognition.gif": "17Ih",
	"./handle-know.png": "r6gq",
	"./home-receipt.png": "5tKg",
	"./homepage/FLG-qrcode.jpg": "mJeQ",
	"./homepage/GZH-qrcode.jpg": "/F6f",
	"./homepage/about-logo.png": "3suq",
	"./homepage/about-us-bg.png": "Fimd",
	"./homepage/access-visa.png": "s7uI",
	"./homepage/back-top-hover.png": "gZeG",
	"./homepage/back-top.png": "JZVd",
	"./homepage/business.png": "GKqd",
	"./homepage/contact-us-bg.png": "/RWi",
	"./homepage/customer-service-hover.png": "fFPG",
	"./homepage/customer-service.png": "JgcQ",
	"./homepage/default-product-type.png": "QQSe",
	"./homepage/enterprise-hope-bg-1.png": "DTqz",
	"./homepage/enterprise-hope-bg.png": "wXQy",
	"./homepage/exclusive-bd-hover.png": "OKs+",
	"./homepage/exclusive-bd.png": "FiRr",
	"./homepage/exclusive-custom-service-hover.png": "unI+",
	"./homepage/exclusive-custom-service.png": "sjR9",
	"./homepage/first-order-discount.png": "Y8zf",
	"./homepage/fixed-right-service/exclusive-service/default-header.png": "Nw7o",
	"./homepage/fixed-right-service/exclusive-service/link-address.png": "FFKm",
	"./homepage/fixed-right-service/exclusive-service/link-email.png": "yEsv",
	"./homepage/fixed-right-service/exclusive-service/link-phone.png": "5cFB",
	"./homepage/fixed-right-service/exclusive-service/link-wxa.png": "xB3b",
	"./homepage/fixed-right-service/exclusive-service/thumbs-active.png": "RYH9",
	"./homepage/fixed-right-service/exclusive-service/thumbs.png": "14SJ",
	"./homepage/fixed-right-service/scroll-top-active.png": "bUFX",
	"./homepage/fixed-right-service/scroll-top.png": "Jg4C",
	"./homepage/fixed-right-service/service-customer.png": "CC2u",
	"./homepage/fixed-right-service/service-feedback-active.png": "XYMq",
	"./homepage/fixed-right-service/service-feedback.png": "oHsO",
	"./homepage/fixed-right-service/service-follow-us-active.png": "O6Eu",
	"./homepage/fixed-right-service/service-follow-us.png": "C9Op",
	"./homepage/fixed-right-service/service-free-registry-active.png": "BrQF",
	"./homepage/fixed-right-service/service-free-registry.png": "0WQT",
	"./homepage/fixed-right-service/service-phone-active.png": "T6Lg",
	"./homepage/fixed-right-service/service-phone.png": "Gnfy",
	"./homepage/follow-us-hover.png": "O+wK",
	"./homepage/follow-us.png": "MiZr",
	"./homepage/honor1.png": "4XIB",
	"./homepage/honor2.png": "wZwe",
	"./homepage/honor3.png": "Scmb",
	"./homepage/icon-8-discount-2x.png": "XTmY",
	"./homepage/icon-address.png": "gw9z",
	"./homepage/icon-airplane-2x.png": "EBhL",
	"./homepage/icon-earliest-depart-date.png": "14u/",
	"./homepage/icon-insurance-2x.png": "b11J",
	"./homepage/icon-insurance-color-2x.png": "wfBd",
	"./homepage/icon-message-delete.png": "7Xi/",
	"./homepage/icon-message-read.png": "cAT8",
	"./homepage/icon-refuse-2x.png": "cqGn",
	"./homepage/icon-register-hover.png": "uNWM",
	"./homepage/icon-register.png": "+ozb",
	"./homepage/icon-right-gray.png": "7jgB",
	"./homepage/info-right-bg.png": "Bf8L",
	"./homepage/iso-cn-1.jpg": "iN9T",
	"./homepage/iso-cn.jpg": "2rWm",
	"./homepage/iso-en-1.jpg": "sCjV",
	"./homepage/iso-en.jpg": "anec",
	"./homepage/join-right.png": "qh8n",
	"./homepage/line-bottom.png": "Pl3p",
	"./homepage/line-top.png": "llV/",
	"./homepage/medical-visa.png": "CYh9",
	"./homepage/more-welfare-hover.png": "ktdc",
	"./homepage/more-welfare.png": "GDTa",
	"./homepage/nav-country-bg.png": "VH3U",
	"./homepage/nav_guide.png": "lNo7",
	"./homepage/nav_message.png": "KW2X",
	"./homepage/nav_special.png": "7x7g",
	"./homepage/nav_visa.png": "Rvt8",
	"./homepage/no-message.png": "jWQ3",
	"./homepage/not-login-footer.png": "9G3C",
	"./homepage/not-login-footer2.png": "0dls",
	"./homepage/on-job-bg.png": "h9Lb",
	"./homepage/opinion-hover.png": "oShv",
	"./homepage/opinion.png": "fdjN",
	"./homepage/question.png": "luAf",
	"./homepage/quick-country-label.png": "WwaD",
	"./homepage/right-arrow-orange-2x.png": "aIpr",
	"./homepage/right-arrow-purple-2x.png": "1pCo",
	"./homepage/select-delete-icon.png": "x2rA",
	"./homepage/select-icon-down.png": "a0tB",
	"./homepage/service-phone-hover.png": "vxui",
	"./homepage/service-phone.png": "Eyxf",
	"./homepage/short-term-study.png": "pdKY",
	"./homepage/timeline-bg.png": "KAwE",
	"./homepage/trip.png": "B2IE",
	"./homepage/visit-friends.png": "bZU2",
	"./homepage/wxa-icon-hover.png": "+qI9",
	"./homepage/wxa-icon.png": "jtJX",
	"./hottest/hottest-product-list.png": "/HTH",
	"./hottest/hottest-product.png": "my55",
	"./hottest/hottest-title-bg.png": "QcbE",
	"./hottest/hottest-title-logo.png": "QiEc",
	"./hottest/hottet-left-arrow.png": "qDZo",
	"./hottest/hottet-right-arrow.png": "Frup",
	"./icon-application.png": "qJFw",
	"./icon-arrow.png": "qF38",
	"./icon-bill.png": "2x8f",
	"./icon-delete.png": "yBG8",
	"./icon-ds160.png": "reBF",
	"./icon-location-active.png": "oWIQ",
	"./icon-location.png": "T6ro",
	"./icon_notify.png": "ncr0",
	"./icons.png": "WnrM",
	"./icons/arrow.png": "g+O3",
	"./icons/recomended.jpg": "Hk70",
	"./icons/seven.png": "h6o7",
	"./icons/warn.png": "8a7F",
	"./img.png": "6kVJ",
	"./index-bg.jpg": "yKNa",
	"./index-video-white.png": "HvV+",
	"./index-video.png": "8DNn",
	"./index/all-country.png": "KNdP",
	"./index/earlist-date.png": "fUnz",
	"./index/embassy-holiday.png": "8wva",
	"./index/entri-bg.png": "JQ6Q",
	"./index/expired.png": "ETo7",
	"./index/footer-slogan.png": "V+JT",
	"./index/gonggao.png": "k6w3",
	"./index/homepage-bg.jpg": "QAfr",
	"./index/icon_1.png": "UaeE",
	"./index/icon_2.png": "MMli",
	"./index/icon_3.png": "gPM4",
	"./index/icon_4.png": "720+",
	"./index/index-activity/icon-special-top.png": "i/9Y",
	"./index/index-activity/no-product.png": "0ew1",
	"./index/index-footer-text1.png": "oRh6",
	"./index/index-footer-text2.png": "UyjX",
	"./index/index-footer.png": "Wc+3",
	"./index/message-checked.png": "LOqk",
	"./index/message.png": "vQPi",
	"./index/more-tips.png": "7vUA",
	"./index/muti-move-left.png": "SmWU",
	"./index/muti-move-right.png": "URZc",
	"./index/nav-arrow.png": "+p55",
	"./index/no-goods.png": "mHFm",
	"./index/palmyou-homepage-bg.jpg": "HBm4",
	"./index/save.png": "sm9e",
	"./index/schedule/schedule-question.png": "OzbP",
	"./index/schedule/schedule-success.png": "SGNx",
	"./index/search-icon.png": "UeFu",
	"./index/title_icon.png": "NG4Z",
	"./index/wechat.png": "ekt6",
	"./index/wx-qrcode.jpg": "g5Fp",
	"./insurance-aseaa.jpg": "sj0j",
	"./insurance-canada.jpg": "knEY",
	"./insurance-icon-hot.png": "H9u4",
	"./insurance-new/icon-add-img.png": "ouu1",
	"./insurance-new/icon-close-hover.png": "CgzD",
	"./insurance-new/icon-close.png": "1+c9",
	"./insurance-new/icon-delete.png": "Ji2C",
	"./insurance-new/icon-desc.png": "TQ+g",
	"./insurance-new/icon-down-gray.png": "eVD6",
	"./insurance-new/icon-down.png": "fAKM",
	"./insurance-new/icon-edit.png": "aWNs",
	"./insurance-new/icon-error.png": "HyHQ",
	"./insurance-new/icon-new.png": "TXbQ",
	"./insurance-new/icon-pay.png": "lbP6",
	"./insurance-new/icon-query.png": "nTlU",
	"./insurance-new/icon-recommend.png": "lTJP",
	"./insurance-new/icon-right-blue.png": "WQus",
	"./insurance-new/icon-select.png": "PmP/",
	"./insurance-new/icon-tips-gray.png": "pKC8",
	"./insurance-new/icon-tips.png": "atWT",
	"./insurance-new/insurance-detail-share.gif": "uboj",
	"./insurance-new/insurance-info/confirm-icon.png": "Yq/l",
	"./insurance-new/insurance-info/next-icon.png": "p1yi",
	"./insurance-new/insurance-info/no-confirm-icon.png": "zOcq",
	"./insurance-new/insurance-info/pre-icon.png": "270t",
	"./insurance-new/insurance-info/selected-icon.png": "7igk",
	"./insurance-new/no-qrcode-icon.png": "ETSI",
	"./insurance-new/order-blue.png": "UYtv",
	"./insurance-new/order-gray.png": "ke0g",
	"./insurance-new/plan-down-blue.png": "NIFw",
	"./insurance-new/plan-down-white.png": "oQqU",
	"./insurance-new/process-1.png": "DfST",
	"./insurance-new/process-2.png": "m2Kz",
	"./insurance-new/process-3.png": "4QEb",
	"./insurance-new/process-4.png": "wP9U",
	"./insurance-new/process-line-long.png": "Q4Ej",
	"./insurance-new/process-line.png": "Vlb4",
	"./insurance-new/qrcode-bg.png": "UL2r",
	"./insurance-new/recharge-discounts-2.png": "2FsI",
	"./insurance-new/recharge-discounts.png": "ROnQ",
	"./insurance-new/recharge-recommend-2.png": "6O17",
	"./insurance-new/recharge-recommend.png": "GbAk",
	"./insurance-new/recognizee-add.png": "qLFy",
	"./insurance-new/review-icon.png": "w7p9",
	"./insurance-new/step-1.png": "M4J5",
	"./insurance-new/step-2.png": "YNt5",
	"./insurance-new/step-3.png": "1NH5",
	"./insurance-new/step-4.png": "UmOU",
	"./insurance-other.jpg": "50dQ",
	"./insurance-product-1.png": "aUH0",
	"./insurance-product-10.png": "foC+",
	"./insurance-product-11.png": "1rWi",
	"./insurance-product-12.png": "jr5C",
	"./insurance-product-13.png": "0SLu",
	"./insurance-product-14.png": "77lm",
	"./insurance-product-15.png": "p0Fj",
	"./insurance-product-16.png": "lt+A",
	"./insurance-product-2.png": "sw8e",
	"./insurance-product-3.png": "0Gw3",
	"./insurance-product-4.png": "dQnf",
	"./insurance-product-5.png": "4kop",
	"./insurance-product-6.png": "Bl5t",
	"./insurance-product-7.png": "Mzlr",
	"./insurance-product-8.png": "Ef0M",
	"./insurance-product-9.png": "qMId",
	"./insurance-refuse.png": "JMQ5",
	"./insurance-shengen.jpg": "dHl3",
	"./insurance/customer-services.png": "M6Mz",
	"./insurance/give.png": "2nGQ",
	"./insurance/guarantee.png": "kops",
	"./insurance/insurance-balance.png": "oJvl",
	"./insurance/insurance-delete.png": "65fE",
	"./insurance/insurance-expend-all.png": "IJLI",
	"./insurance/insurance-info.png": "0xY1",
	"./insurance/insurance-process.png": "Iqmj",
	"./insurance/insurance-shield.png": "t4Hh",
	"./insurance/insurance-success.png": "bQZm",
	"./insurance/insurance-warn.png": "RzUd",
	"./insurance/money.png": "SroW",
	"./insurance/passed.png": "VmBN",
	"./insurance/process-1.png": "iHNk",
	"./insurance/process-2.png": "r8AU",
	"./insurance/process-3.png": "cfup",
	"./insurance/process-4.png": "AA15",
	"./insurance/recognizee-add.png": "gtWg",
	"./insurance/recognizee-bg.png": "lstP",
	"./insurance/selected.png": "sIKM",
	"./insurance/status-cancel.png": "Maa6",
	"./insurance/status-common.png": "mr8k",
	"./insurance/status-process.png": "ts3Q",
	"./insurance/tip.png": "cvA8",
	"./insurance/流程.png": "Z9jr",
	"./interview/address.png": "B0hf",
	"./interview/attention.png": "Joe6",
	"./interview/download.png": "mvsJ",
	"./interview/download_interview.png": "ELWd",
	"./interview/get_finger.png": "Yf+B",
	"./interview/material.png": "lK0f",
	"./interview/process.png": "nZjy",
	"./interview/tel_survey.png": "Yfxc",
	"./interview/warn_cue.png": "y6uz",
	"./invoice-manage/guide-alipay.png": "+pNr",
	"./invoice-manage/guide-wxpay.png": "VKQS",
	"./invoice-manage/icon-lock.png": "du8E",
	"./invoice-manage/icon-refuse.png": "7/Vi",
	"./invoice-manage/icon-selected.png": "4zwT",
	"./invoice-manage/icon-success.png": "CmAl",
	"./invoice-manage/icon-unselected.png": "iIPw",
	"./invoice-manage/icon-warn.png": "Q4UH",
	"./invoice-manage/logo-alipay.png": "5Rav",
	"./invoice-manage/logo-wxpay.png": "sh+M",
	"./invoice-manage/none-order.png": "TxFc",
	"./ios-code.png": "DWfq",
	"./job0.png": "W7GO",
	"./job1.png": "V+mO",
	"./job2.png": "s8bf",
	"./job3.png": "HO2M",
	"./job4.png": "tMIo",
	"./jobg0.png": "u4bv",
	"./jobg1.png": "WG+/",
	"./jobg2.png": "70ox",
	"./jobg3.png": "Ol9i",
	"./jobg4.png": "2EQ4",
	"./joinUs-bg.jpg": "h38m",
	"./join_now.png": "9EvU",
	"./join_now_close.png": "HY3G",
	"./july/banner.jpg": "SLh/",
	"./july/noproduct.png": "84OB",
	"./june/Summer_copy.png": "/pjQ",
	"./june/Summer_noproduct.png": "LoPa",
	"./june/Summer_top.png": "I1ep",
	"./location-gray.png": "atmr",
	"./location.png": "mJc/",
	"./login-back.png": "I62X",
	"./login-country-all.png": "iXJY",
	"./login-search.png": "cu+z",
	"./login.png": "u5zf",
	"./logo.jpg": "3Xst",
	"./logo.png": "Vpqn",
	"./mala/airplane.png": "ztuz",
	"./mala/slanting.png": "baqO",
	"./mala/step1.png": "kopS",
	"./mala/step2.png": "T5nw",
	"./mala/step3.png": "q6aK",
	"./mala/step4.png": "IztG",
	"./mala/tips_done.png": "BUJv",
	"./mala/tips_loading1.png": "ZuGt",
	"./mala/tips_loading2.png": "GKUO",
	"./mala/tips_reject.png": "Iqfe",
	"./mala/tips_small_done.png": "ZaNc",
	"./mala/tips_small_fail.png": "yLnc",
	"./mala/tips_small_loading.png": "d93a",
	"./mala/tips_waiting.png": "tLZ4",
	"./mala/visa-photo.jpg": "4FMF",
	"./mala/zoomin.png": "cZul",
	"./mala/zoomout.png": "/L2x",
	"./mala/极速.png": "K2a/",
	"./malaysia.jpg": "MRud",
	"./meiya.gif": "HEyH",
	"./money.png": "Ih2a",
	"./more-arrow.png": "rQza",
	"./moren.jpg": "1/Ts",
	"./multi-image-preview/icon-close.png": "lXz5",
	"./multi-image-preview/icon-left-big.png": "NXNg",
	"./multi-image-preview/icon-left-small.png": "mtbw",
	"./multi-image-preview/icon-magnifier.png": "ogm8",
	"./multi-image-preview/icon-right-big.png": "WVE9",
	"./multi-image-preview/icon-right-small.png": "3CAK",
	"./new-user-d.png": "LST9",
	"./new-user.png": "Rf5f",
	"./new-user/address-bar.png": "a1rI",
	"./new-user/address-nodata.png": "y5+2",
	"./new-user/avatar-default.png": "Yj43",
	"./new-user/balance-nodata.png": "Oo+o",
	"./new-user/coupon-bg.png": "ON0C",
	"./new-user/coupon-invalid-bg.png": "gm6Q",
	"./new-user/coupon-nodata.png": "QzVz",
	"./new-user/coupon-used-bg.png": "MWLk",
	"./new-user/default-bg.png": "IVWG",
	"./new-user/icon-api.png": "iBBb",
	"./new-user/icon-delete-gray.png": "u4sL",
	"./new-user/icon-delete.png": "C1t0",
	"./new-user/icon-edit-gray.png": "LA4j",
	"./new-user/icon-edit.png": "HtGd",
	"./new-user/icon-email.png": "hI0G",
	"./new-user/icon-fliggy.png": "0uSc",
	"./new-user/icon-right-blue.png": "W6LE",
	"./new-user/icon-right.png": "AB3e",
	"./new-user/icon-set-default-gray.png": "Ymzh",
	"./new-user/icon-set-default.png": "RSrW",
	"./new-user/icon-tips.png": "6Kcm",
	"./new-user/nodata-member.png": "X1BI",
	"./new-user/nodata-shop.png": "SmPz",
	"./new-user/recharge.gif": "3XCT",
	"./noproduct.png": "/fhM",
	"./north-and-south-pole.jpg": "7jnC",
	"./not-pass.png": "sSfj",
	"./notice-w.png": "wqMm",
	"./notice.png": "sF+5",
	"./number.png": "VMZg",
	"./official-accounts-qrcode-bottom.png": "gsB1",
	"./offline-express-disabled.png": "UvRj",
	"./offline-express-hover.png": "6fpP",
	"./offline-express.png": "YMxH",
	"./on-job/example-img.png": "tAVO",
	"./on-job/icon-back.png": "xHgP",
	"./on-job/icon-selected.png": "AuFE",
	"./on-job/icon-tips-red.png": "/iac",
	"./on-job/on-job-nodata.png": "oImL",
	"./on-job/photo-icon.png": "+yRQ",
	"./on-job/search-nodata.png": "KPt3",
	"./on-job/step-1.png": "/ssV",
	"./on-job/step-2.png": "lSJj",
	"./on-job/step-3.png": "ycb7",
	"./on-job/step-4.png": "Mru3",
	"./on-job/step-arrow.png": "LIeE",
	"./on-job/tips-gray.png": "tBky",
	"./on-job/translate-img.png": "jKc1",
	"./online-upload-hover.png": "vjui",
	"./online-upload.png": "BIWv",
	"./order-bg.png": "E5Il",
	"./order-detail/cue.png": "lubO",
	"./order-detail/document.png": "pOTw",
	"./order-detail/icon-upload.png": "B8j2",
	"./order-detail/icon.png": "AoIm",
	"./order-detail/schedule-block/doing.png": "V+M7",
	"./order-detail/schedule-block/done.png": "s0/o",
	"./order-detail/schedule-block/mask-left.png": "y/e/",
	"./order-detail/schedule-block/mask-right.png": "SURk",
	"./order-detail/schedule-block/schedule-arrow.png": "G9jR",
	"./order-detail/schedule-block/schedule-bg.png": "aNiF",
	"./order-detail/schedule-block/undone.png": "gNBo",
	"./order-detail/upload.png": "lt56",
	"./order/evaluate.png": "N5Z/",
	"./order/icon-add.png": "hZR/",
	"./order/icon-copy-checked.png": "cZJ4",
	"./order/icon-delete-active.png": "1NV2",
	"./order/icon-delete.png": "/Oe9",
	"./order/icon-share.png": "zLyT",
	"./order/icon-update-active.png": "+gWK",
	"./order/icon-update.png": "4mUw",
	"./order/icon-使馆假期／近两月@2x.png": "H3sY",
	"./order/icon-保险@2x.png": "yPCH",
	"./order/icon-勾@2x.png": "bAIk",
	"./order/icon-勾选@2x.png": "3Ni2",
	"./order/icon-在线上传-1@2x.png": "HzN9",
	"./order/icon-在线上传-2@2x.png": "rYbu",
	"./order/icon-最新公告@2x.png": "kdc7",
	"./order/icon-最早可预约时间@2x.png": "oB0t",
	"./order/icon-线下邮寄-1@2x.png": "xPIa",
	"./order/icon-线下邮寄-2@2x.png": "gCQR",
	"./order/icon_pop.png": "OJ9A",
	"./order/item-bg-sign.png": "BZXt",
	"./order/no_insurance.png": "q5+O",
	"./order/no_order.png": "dOxB",
	"./order/pay-title.png": "oiK0",
	"./order/reject_warn.png": "IMQj",
	"./order/triangle.png": "shrd",
	"./ordering/animation.gif": "NcZi",
	"./ordering/balance.png": "lp8m",
	"./ordering/date.png": "J1uw",
	"./ordering/gray-shield.png": "BgLG",
	"./ordering/green-bubble-input.png": "1K4a",
	"./ordering/green-shield.png": "BKXW",
	"./ordering/icon_app_check.png": "jk9N",
	"./ordering/more.png": "blkW",
	"./ordering/orange-bubble-input.png": "px+S",
	"./ordering/orange-reject-product-tag.png": "2WkF",
	"./ordering/orange-shield.png": "7P1N",
	"./ordering/red-reject-product-tag.png": "yrM3",
	"./ordering/reject-product-star.png": "L0kJ",
	"./ordering/search_no_data.png": "ZIWo",
	"./ordering/selected-reject-product.png": "v/b4",
	"./ordering/share-guide.png": "J23T",
	"./ordering/static.png": "1BWY",
	"./ordering/step_1.png": "r7pF",
	"./ordering/step_2.png": "ialG",
	"./ordering/step_3.png": "wiqQ",
	"./ordering/tel.png": "T6kg",
	"./ordering/tips.png": "U+ta",
	"./ordering/title-safe-icon.png": "8Qso",
	"./ordering/title-safe.png": "iNse",
	"./ordering/transpond.png": "SYvn",
	"./ota-order/close_product_bg.jpg": "ZcUg",
	"./ota-order/fliggy.png": "Z/v+",
	"./ota-order/logo-feizhu.png": "azPq",
	"./ota-order/logo-mafengwo.png": "q3E9",
	"./ota-order/logo-meituan.png": "XMol",
	"./ota-order/logo-qiongyou.png": "BbUl",
	"./ota-order/logo-qunaer.png": "MZe4",
	"./ota-order/logo-tongcheng.png": "0c60",
	"./ota-order/logo-xiecheng.png": "TkWj",
	"./ota-order/none-store.png": "kO22",
	"./ota-order/success.png": "hV9d",
	"./ota-order/visa.png": "3OrT",
	"./other-express-type.png": "oV6C",
	"./passed.png": "XxkZ",
	"./payway14.png": "4Xsm",
	"./payway15.png": "zECy",
	"./payway16.png": "Q9xA",
	"./payway2.png": "2Ppv",
	"./payway3.png": "0AVI",
	"./pdf.png": "tcik",
	"./people-count.png": "1a2z",
	"./phone.png": "p9O2",
	"./pingan.gif": "dWVj",
	"./place_order.png": "fct0",
	"./plane/ali-pay-guide.png": "9SWO",
	"./plane/arrow-back.png": "kZX9",
	"./plane/icon-close.png": "JAYI",
	"./plane/icon-hot.png": "n7DH",
	"./plane/icon-new.png": "gfKg",
	"./plane/icon-radio-active.png": "De5Z",
	"./plane/icon-radio.png": "ZPIk",
	"./plane/icon-search.png": "eus0",
	"./plane/pay-alipay.png": "xJx3",
	"./plane/pay-big.png": "FQqJ",
	"./plane/pay-company.png": "2on+",
	"./plane/pay-lock.png": "GFqo",
	"./plane/pay-unionpay.png": "0G4+",
	"./plane/pay-wxpay.png": "c9go",
	"./plane/product-date-bg.png": "s1/h",
	"./plane/product-item-separate.png": "Px+t",
	"./plane/quick-country-label-blue.png": "+jIJ",
	"./plane/wx-pay-guide.png": "OR7E",
	"./play.png": "QaeE",
	"./polygon-grey@2x.png": "7yTd",
	"./polygon-grey@3x.png": "TMFh",
	"./polygon@2x.png": "n5WX",
	"./polygon@3x.png": "Fd4D",
	"./price.png": "0Uyi",
	"./print-close.png": "kG9M",
	"./print-info.png": "tR4T",
	"./print-print.png": "OtmW",
	"./product-detail/calendar-left-1.png": "pz4R",
	"./product-detail/calendar-left-hover-1.png": "fTPg",
	"./product-detail/calendar-left-hover.png": "FD2B",
	"./product-detail/calendar-left.png": "bRgF",
	"./product-detail/calendar-right-hover.png": "AFcA",
	"./product-detail/calendar-right.png": "EYfx",
	"./product-detail/coupon-bg.png": "wpzp",
	"./product-detail/detail-answer.png": "m6yJ",
	"./product-detail/detail-special-price-coupon.png": "kmbI",
	"./product-detail/detail-special-price-coupon1.png": "1l7Z",
	"./product-detail/detail-special-price-new-people-coupon.png": "p3n+",
	"./product-detail/detail-special-price-new-people-coupon1.png": "I5Fa",
	"./product-detail/detail_like.png": "iM6z",
	"./product-detail/detail_liked.png": "MLNN",
	"./product-detail/edit-icon.png": "oz7r",
	"./product-detail/icon-apply-time.png": "+ssJ",
	"./product-detail/icon-apply.png": "C8on",
	"./product-detail/icon-arrow-down.png": "jYEJ",
	"./product-detail/icon-close.png": "xRRJ",
	"./product-detail/icon-coupon-bg.png": "d5nT",
	"./product-detail/icon-depart-date.png": "My6m",
	"./product-detail/icon-down-blue.png": "j2P4",
	"./product-detail/icon-down-gray.png": "FBWC",
	"./product-detail/icon-embassy-holiday-1.png": "QkRb",
	"./product-detail/icon-embassy-holiday.png": "jk59",
	"./product-detail/icon-entry-count.png": "UxQ0",
	"./product-detail/icon-identity-select.png": "EFkF",
	"./product-detail/icon-location-2.png": "0ucO",
	"./product-detail/icon-location.png": "LtAa",
	"./product-detail/icon-material-elec.png": "CvqR",
	"./product-detail/icon-material-mail.png": "WcwW",
	"./product-detail/icon-material-paper.png": "YPHa",
	"./product-detail/icon-peer-address.png": "lD9h",
	"./product-detail/icon-peer-name.png": "Dorm",
	"./product-detail/icon-question.png": "FPkq",
	"./product-detail/icon-right.png": "1guF",
	"./product-detail/icon-search-input.png": "cUc2",
	"./product-detail/icon-stay-time.png": "iUjS",
	"./product-detail/icon-validity.png": "kW4m",
	"./product-detail/icon-visa-rate.png": "cV7M",
	"./product-detail/list-question.png": "f+q7",
	"./product-detail/list_like.png": "wXfT",
	"./product-detail/list_liked.png": "y3tV",
	"./product-detail/nodata-product.png": "cw3k",
	"./product-detail/peer-info-bg.png": "6u4N",
	"./product-detail/print-masterial-bg.png": "EYgF",
	"./product-detail/product-out.png": "eL+m",
	"./product-detail/special-price-arrow-1.png": "OlC/",
	"./product-detail/special-price-arrow.png": "1ESz",
	"./product-detail/special-price-coupon.png": "UdV3",
	"./product-detail/special-price-coupon1.png": "64tC",
	"./product-detail/special-price-new-people-coupon.png": "nkds",
	"./product-detail/special-price-new-people-coupon1.png": "Rjjd",
	"./product-detail/special-price-small.png": "sODI",
	"./product-detail/special-price.png": "Mu6E",
	"./product-detail/step-icon.png": "OVOx",
	"./product-detail/visa-reject-refund-product.png": "4UqY",
	"./product-detail/visa-reject-refund-product1.png": "YBWf",
	"./product/bg-wxa-2x.png": "jJBW",
	"./product/bg.jpg": "Uywr",
	"./product/coupon-num-background.png": "ohP4",
	"./product/download_icon.png": "4Zzk",
	"./product/gou.png": "sRVA",
	"./product/icon-close.png": "0Bhp",
	"./product/icon-download.png": "BBFl",
	"./product/icon-edit.png": "0fDt",
	"./product/icon-print.png": "OL5e",
	"./product/material-close.png": "C904",
	"./product/material-download.png": "Jy4T",
	"./product/new-peer.png": "ucL8",
	"./product/product-download.png": "f2RE",
	"./product/product-print-clock.png": "VXMv",
	"./product/product-print.png": "ZtEz",
	"./product/product-title-call.png": "cPe/",
	"./product/product-title-clock.png": "yEK1",
	"./product/reject-product-checked.png": "phnu",
	"./product/reject-product-no-checked.png": "3IM6",
	"./product/tips.png": "3oiX",
	"./products-no-product.png": "6gjh",
	"./products/hot-img.png": "ele+",
	"./products/hottest-product-list.png": "JzBK",
	"./products/jia.png": "eVRk",
	"./products/more-hot.png": "dnAd",
	"./products/special_price.png": "vmjT",
	"./products/stamp-delivery.png": "r9CV",
	"./products/stamp-dianziqian.png": "bhPU",
	"./products/stamp-interview.png": "prjT",
	"./products/transact_person.png": "xxh0",
	"./products/transact_person_white.png": "ATfA",
	"./products/transact_time.png": "xQXR",
	"./products/transact_time_white.png": "ReSo",
	"./products/visa_bg_business.png": "UtWL",
	"./products/visa_bg_medical.png": "esqy",
	"./products/visa_bg_others.png": "klx/",
	"./products/visa_bg_study_abroad.png": "M4ko",
	"./products/visa_bg_travel.png": "qvOW",
	"./products/visa_bg_visit.png": "sXLI",
	"./products/visa_business.png": "2xzs",
	"./products/visa_medical.png": "RyZK",
	"./products/visa_others.png": "/pkM",
	"./products/visa_study_abroad.png": "tpc1",
	"./products/visa_travel.png": "oeM0",
	"./products/visa_visit.png": "rK2A",
	"./products/xiu.png": "82Dn",
	"./qixin.png": "Au0i",
	"./quote.png": "4iAB",
	"./recharge-gou.png": "TjpF",
	"./recharge.png": "Se/M",
	"./recharge/activity-d.png": "AFmT",
	"./recharge/activity.png": "HENS",
	"./recharge/attended.png": "JCMf",
	"./recharge/icon_upload.png": "QtMq",
	"./recomend.png": "Qu0n",
	"./recommend-o.png": "fy+x",
	"./recommend.png": "8NIo",
	"./region.png": "2y/B",
	"./reject.png": "wxnk",
	"./right.png": "RIg6",
	"./sc.png": "hqWd",
	"./schengen-1.jpg": "QwLt",
	"./schengen-2.jpg": "vso7",
	"./send-express.png": "4kdL",
	"./send-mail.png": "pp62",
	"./send-online.png": "QscX",
	"./service-includes.png": "PiIC",
	"./service/service-active.png": "sfs/",
	"./service/service-wechat.png": "yH89",
	"./service/service.png": "RTYj",
	"./service_online.png": "3BXV",
	"./service_tel.png": "RhWQ",
	"./sf-express.png": "H7Dw",
	"./share-code.png": "YEw9",
	"./share.gif": "Sb2Z",
	"./share2.gif": "Ohgx",
	"./shengen_region.png": "Fbes",
	"./shop-bg.png": "sZLP",
	"./shop-logo.png": "SUto",
	"./slogan.png": "EYN7",
	"./sorry.png": "UzVD",
	"./sp0.png": "cIzX",
	"./sp0bg.png": "NguV",
	"./sp1.png": "CGC7",
	"./sp2.png": "LuZ9",
	"./sp2bg.png": "wLdK",
	"./sp3.png": "FOsS",
	"./sp4.png": "tq7S",
	"./sp4bg.png": "Rqyc",
	"./sp5.png": "VcJN",
	"./ssq-mp.jpg": "giUt",
	"./store-blue.png": "lSnB",
	"./store.png": "jDOK",
	"./taiwan.jpg": "QMVG",
	"./tel.png": "9Jj/",
	"./toHome.png": "31gt",
	"./tx1.jpg": "Y92e",
	"./tx2.jpg": "fGf8",
	"./tx3.jpg": "4saF",
	"./tx4.jpg": "nA/s",
	"./tx5.jpg": "sl5Y",
	"./tx6.jpg": "6eU7",
	"./unionpay.png": "JVZ2",
	"./upload/delete.png": "Dsva",
	"./upload/divorce-sample.png": "6PDE",
	"./upload/edit-ocr.png": "w1tr",
	"./upload/forbid.png": "r+G6",
	"./upload/human.png": "qvyZ",
	"./upload/icon-crop-1.png": "e1oK",
	"./upload/icon-crop.png": "YBQ7",
	"./upload/icon-grow.png": "Dwp5",
	"./upload/icon-li.png": "58Fn",
	"./upload/icon-move-1.png": "wRrN",
	"./upload/icon-move.png": "a6lO",
	"./upload/icon-rotate.png": "HAI4",
	"./upload/icon-shrink.png": "alJN",
	"./upload/id-card-back-sample.png": "K57H",
	"./upload/id-card-front-sample.png": "urPs",
	"./upload/married-sample.png": "rkap",
	"./upload/not-pass.png": "spP3",
	"./upload/paper-icon.png": "Un8V",
	"./upload/pass.png": "wWKj",
	"./upload/passport-sample.png": "3d5z",
	"./upload/sample.png": "y8t2",
	"./upload/upload-icon.png": "jlx3",
	"./upload/upload.png": "H+WH",
	"./upload/use-guide.png": "cCCY",
	"./upload/zoomin.png": "gZV+",
	"./upload/zoomout.png": "AWwn",
	"./user-insurance/icon-tips-blue.png": "TLIu",
	"./user/balance-new-label.png": "KBrO",
	"./user/balance-usage.png": "52zM",
	"./user/nav-peo-hover.png": "R8mK",
	"./user/nav-peo.png": "gKsJ",
	"./user/nav-store-hover.png": "53/k",
	"./user/nav-store.png": "m1ke",
	"./user/null-shop.png": "c5sD",
	"./user/recharge-discount.png": "qLMP",
	"./user/role-error.png": "KRqg",
	"./user/role-success.png": "jab+",
	"./video-play.jpg": "pbSJ",
	"./visa-api/api-1.png": "/mjZ",
	"./visa-api/api-2.png": "17AH",
	"./visa-api/api-3.png": "UQv1",
	"./visa-api/api-4.png": "SPqq",
	"./visa-api/api-5.png": "ZFcD",
	"./visa-api/api-6.png": "KkR4",
	"./visa-api/api-bg.png": "uqx8",
	"./visa-api/banner.jpg": "FXPQ",
	"./visa-api/contract-bg.png": "r02k",
	"./visa-api/cooperate-1.png": "6X5s",
	"./visa-api/cooperate-2.png": "Or7q",
	"./visa-api/flow-1.png": "M3Af",
	"./visa-api/flow-2.png": "eCuG",
	"./visa-api/flow-3.png": "wHsU",
	"./visa-api/flow-4.png": "JeMC",
	"./visa-api/goods-1.png": "l75d",
	"./visa-api/goods-2.png": "Uj30",
	"./visa-api/goods-3.png": "zLOR",
	"./visa-api/goods-4.png": "6PT9",
	"./visa-api/goods-5.png": "4H5r",
	"./visa-api/goods-6.png": "hYPu",
	"./visa-api/icon-arrow.png": "4ywH",
	"./visa-api/icon-phone.png": "yxUP",
	"./visa-infos.png": "XkTY",
	"./wechat-logo.png": "Zlk8",
	"./wechat.png": "lk0u",
	"./weixin.png": "hCXm",
	"./wx-phone.png": "xBq5",
	"./wxa-bind-page.jpg": "m0vO",
	"./wxa_code.jpg": "aILC",
	"./wxpay.png": "xWTo",
	"./zixun-hover.png": "Y2GE",
	"./zixun.png": "TrR6",
	"./极速.png": "Tt3y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "deFR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*$
// module id = deFR
// module chunks = 4